import type { DirectiveBinding } from 'vue'
import { useUserStore } from '@/stores/user'

const hasRole = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const userStore = useUserStore()
    const has = userStore.hasRole(binding.value)
    // console.log('hasPermit', has, binding.value)
    if (!has) {
      // console.log('hasPermit el.parentNode', el.parentNode)
      el.parentNode && el.parentNode.removeChild(el)
    }
  },
  // 值更新时调用
  update(el: HTMLElement, binding: DirectiveBinding) {
    const hasPermit = binding.value
    if (hasPermit) {
      el.style.display = '' // 显示元素
    } else {
      el.style.display = 'none' // 隐藏元素
    }
  }
}

export default hasRole
